
import { css } from 'lit';
export default css`
:host{
  --pc-hero-height-with-image:89px;
  --pc-hero-height-without-image:82px;
  --pc-hero-border-width-mobile:3px;
  --pc-hero-border-width:4px;

  display:block;
  background-color:var(--neutral-dark-eggplant);
}

.hero-container{
  display:block;
  overflow:hidden;
}

.container{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-8);
}

.content{
  display:flex;
  flex-direction:column;
  justify-content:center;
  gap:var(--spacing-4);
  margin:0;
  border-right:0;
  color:var(--primary-white);
}

@media (min-width: 992px){
  .container{
    gap:0;
  }

  .content{
    gap:var(--spacing-6);
    margin:0;
    padding:var(--spacing-0);
    border-right:0;
  }
}
`;